import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import EvidenceLibraryPage from "./pages/EvidenceLibraryPage";
import PartnerFirmsPage from "./pages/PartnerFirmsPage";
import NewsletterPage from "./pages/NewsletterPage";
import MediaPage from "./pages/MediaPage";
import PhotoPackagePage from "./pages/PhotoPackagePage";
import ExecutionGapTestPage from "./pages/ExecutionGapTestPage";
import GapTestAdminPage from "./pages/GapTestAdminPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/evidence" element={<EvidenceLibraryPage />} />
            <Route path="/partners" element={<PartnerFirmsPage />} />
            <Route path="/newsletter" element={<NewsletterPage />} />
            <Route path="/newsletter/:slug" element={<NewsletterPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/photo-package" element={<PhotoPackagePage />} />
            <Route path="/execution-gap-test" element={<ExecutionGapTestPage />} />
            <Route path="/admin/gap-test" element={<GapTestAdminPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
